/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/prop-types */
import Image from "next/future/image";
import React from "react";

function AboutPage({ data, language }) {
  return (
    <div className="content">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h3
              className="title"
              dangerouslySetInnerHTML={{
                __html:
                  language === "EN"
                    ? data?.en_title_about
                    : data?.id_title_about,
              }}
            ></h3>
            <h4
              className="subtitle"
              dangerouslySetInnerHTML={{
                __html:
                  language === "EN"
                    ? data?.en_subtitle_about
                    : data?.id_subtitle_about,
              }}
            ></h4>
            <p
              dangerouslySetInnerHTML={{
                __html:
                  language === "EN" ? data?.en_desc_about : data?.id_desc_about,
              }}
            ></p>
          </div>
          <div className="col-md-6">
            {/* <img
              src={language === 'EN' ? data?.en_img_about : data?.id_img_about}
              alt={
                language === 'EN'
                  ? data?.en_alt_img_about
                  : data?.id_alt_img_about
              }
            /> */}

            <Image
              src={language === "EN" ? data?.en_img_about : data?.id_img_about}
              alt={
                language === "EN"
                  ? data?.en_alt_img_about
                  : data?.id_alt_img_about
              }
              width={546}
              height={304}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
